import React, { useContext } from "react";
import { ScrollPage } from "@appidea/react-scroll-motion";
import styles from "./Pricing.module.scss";
import classNames from "classnames";
import { gradients } from "../../../colors";
import { getMessage, Message, MessageContext } from "@messageformat/react";

export const Pricing = ({ page }) => {
  const isSmallScreen = window.innerWidth < 600;
  const messageContext = useContext(MessageContext);

  const pricingPlans = [
    {
      title: getMessage(
        messageContext,
        "landingPage.pricing.plans.start.title",
      )(),
      price: getMessage(
        messageContext,
        "landingPage.pricing.plans.start.price",
      )(),
      priceDescription: getMessage(
        messageContext,
        "landingPage.pricing.plans.start.priceDescription",
      )(),
      features: [
        getMessage(
          messageContext,
          "landingPage.pricing.plans.start.feature1",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.start.feature2",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.start.feature3",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.start.feature4",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.start.feature5",
        )(),
      ],
      addition: getMessage(
        messageContext,
        "landingPage.pricing.plans.start.addition",
      )(),
      cta: getMessage(messageContext, "landingPage.pricing.plans.start.cta")(),
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.pricing.plans.enterprise.title",
      )(),
      price: getMessage(
        messageContext,
        "landingPage.pricing.plans.enterprise.price",
      )(),
      priceDescription: getMessage(
        messageContext,
        "landingPage.pricing.plans.enterprise.priceDescription",
      )(),
      features: [
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature1",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature2",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature3",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature4",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature5",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature6",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature7",
        )(),
        getMessage(
          messageContext,
          "landingPage.pricing.plans.enterprise.feature8",
        )(),
      ],
      cta: getMessage(
        messageContext,
        "landingPage.pricing.plans.enterprise.cta",
      )(),
    },
  ];

  return (
    <div
      style={{
        background: gradients.secondary,
        display: "flex",
        flexDirection: "column",
        zIndex: 999,
        position: "relative",
      }}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Message id="landingPage.pricing.title" />
          </h2>
          <p className={styles.subtitle}>
            <Message id="landingPage.pricing.subtitle" />
          </p>
        </div>

        <div className={styles.pricingGrid}>
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={classNames(styles.pricingCard, {
                [styles.pricingCardFeatured]: plan.featured,
              })}
            >
              <h3 className={styles.cardTitle}>{plan.title}</h3>
              <div className={styles.price}>{plan.price}</div>
              <p className={styles.priceDescription}>{plan.priceDescription}</p>

              <ul className={styles.featuresList}>
                {plan.features.map((feature, idx) => (
                  <li key={idx} className={styles.feature}>
                    {feature}
                  </li>
                ))}
              </ul>

              {plan.addition && (
                <p className={styles.addition}>{plan.addition}</p>
              )}

              <button
                className={styles.ctaButton}
                onClick={() => (window.location = "https://eepurl.com/i1SNeA")}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
